var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDetailsEditingStageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.5,
    r: 15,
    fill: "#EEECF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1525_32548",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 18,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.54053,
    y: 7.04132,
    width: 16.9167,
    height: 16.9167,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1525_32548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6392 11.975L20.9695 10.53L19.5246 9.86037L20.9695 9.19075L21.6392 7.74579L22.3088 9.19075L23.7537 9.86037L22.3088 10.53L21.6392 11.975ZM13.5333 11.975L12.8636 10.53L11.4187 9.86037L12.8636 9.19075L13.5333 7.74579L14.2029 9.19075L15.6478 9.86037L14.2029 10.53L13.5333 11.975ZM21.6392 20.0809L20.9695 18.6359L19.5246 17.9663L20.9695 17.2967L21.6392 15.8517L22.3088 17.2967L23.7537 17.9663L22.3088 18.6359L21.6392 20.0809ZM11.1367 22.3364L9.16312 20.3628C9.02215 20.2218 8.95166 20.0515 8.95166 19.8518C8.95166 19.6521 9.02215 19.4817 9.16312 19.3408L17.0223 11.4816C17.1633 11.3406 17.3336 11.2701 17.5333 11.2701C17.7331 11.2701 17.9034 11.3406 18.0444 11.4816L20.018 13.4552C20.159 13.5961 20.2294 13.7665 20.2294 13.9662C20.2294 14.1659 20.159 14.3362 20.018 14.4772L12.1588 22.3364C12.0178 22.4774 11.8475 22.5479 11.6478 22.5479C11.448 22.5479 11.2777 22.4774 11.1367 22.3364ZM11.6654 20.8562L16.7051 15.7812L15.7183 14.7944L10.6433 19.8342L11.6654 20.8562Z",
    fill: "#493AB1"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDetailsEditingStageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DetailsEditingStageIcon.c7717003.svg";
export { ForwardRef as ReactComponent };